import { useCallback, useEffect, useSyncExternalStore } from 'react';
import {
  selectGroupGuid,
  selectUserGuid,
  useAppSelector,
} from 'slices/commonSelectors';
import {
  eventsSeenStorageKey,
  getLastSeenSnapshot,
  markEventsSeen,
  seedLastSeenAt,
  subscribeEventsSeenState,
} from './eventsSeenState';

export function useEventsSeenState() {
  const userGuid = useAppSelector(selectUserGuid);
  const groupGuid = useAppSelector(selectGroupGuid);
  const key =
    userGuid && groupGuid ? eventsSeenStorageKey(userGuid, groupGuid) : '';

  const lastSeenAt = useSyncExternalStore(
    subscribeEventsSeenState,
    () => getLastSeenSnapshot(key),
    () => null
  );

  useEffect(() => {
    if (!key) return;
    seedLastSeenAt(key);
  }, [key]);

  const markSeen = useCallback(() => {
    if (!key) return;
    markEventsSeen(key);
  }, [key]);

  return { lastSeenAt, markSeen };
}
